// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3J12d","placeholdersHeader":"styles_placeholdersHeader__ds4Pu","editorStyle":"styles_editorStyle__Ud9lL","placeholdersBox":"styles_placeholdersBox__19OK3"};